import { PersonalApiKeysSortField } from "components/ApiKeys/PersonalApiKeys/Table/useSort";
import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const API_KEYS_PERSONAL_COLUMNS_STORAGE_KEY = "organizationPersonalApiKeysColumnsConfig";
export const API_KEYS_PERSONAL_FILTERS_ORDER_KEY = "organizationPersonalApiKeysFiltersOrder";

export enum API_KEYS_PERSONAL_COLUMN_ID {
  NAME = "NAME",
  ISSUES = "ISSUES",
  KEY_ID = "KEY_ID",
  OWNER = "OWNER",
  CREATED_AT = "CREATED_AT",
  EXPIRES_AT = "EXPIRES_AT",
  LAST_USED = "LAST_USED",
  ACTIONS = "ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

const BASE_COLUMN_META = {
  maxWidth: 400,
  resizable: true,
  allowsSorting: true,
  canHide: false,
  canMove: false,
  canPin: false,
};

export const API_KEYS_PERSONAL_COLUMN_CONFIG: Record<API_KEYS_PERSONAL_COLUMN_ID, TableColumnMeta> =
  {
    [API_KEYS_PERSONAL_COLUMN_ID.NAME]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.NAME,
      title: "Name",
      minWidth: 150,
      defaultWidth: 240,
      maxWidth: MAX_CELL_WIDTH,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.ISSUES]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.ISSUES,
      title: "Issues",
      minWidth: 100,
      defaultWidth: 140,
      allowsSorting: false,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.KEY_ID]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.KEY_ID,
      title: "Key ID",
      minWidth: 200,
      defaultWidth: 300,
      maxWidth: MAX_CELL_WIDTH,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.OWNER]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.OWNER,
      title: "Owner",
      minWidth: 120,
      defaultWidth: 180,
      maxWidth: MAX_CELL_WIDTH,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.CREATED_AT]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.CREATED_AT,
      title: "Created at",
      minWidth: 120,
      defaultWidth: 160,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.EXPIRES_AT]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.EXPIRES_AT,
      title: "Expires at",
      minWidth: 120,
      defaultWidth: 160,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.LAST_USED]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.LAST_USED,
      title: "Last used",
      minWidth: 120,
      defaultWidth: 160,
    },
    [API_KEYS_PERSONAL_COLUMN_ID.ACTIONS]: {
      ...BASE_COLUMN_META,
      id: API_KEYS_PERSONAL_COLUMN_ID.ACTIONS,
      title: "API key actions",
      noHeader: true,
      minWidth: 60,
      defaultWidth: 60,
      maxWidth: 60,
      resizable: false,
      allowsSorting: false,
      configurable: false,
    },
  };

type ApiKeysPersonalSortKey = keyof Pick<
  typeof API_KEYS_PERSONAL_COLUMN_ID,
  "NAME" | "KEY_ID" | "OWNER" | "CREATED_AT" | "EXPIRES_AT" | "LAST_USED"
>;

export const API_KEYS_PERSONAL_SORT_CONFIG: Record<
  ApiKeysPersonalSortKey,
  PersonalApiKeysSortField
> = {
  [API_KEYS_PERSONAL_COLUMN_ID.NAME]: "name",
  [API_KEYS_PERSONAL_COLUMN_ID.KEY_ID]: "id",
  [API_KEYS_PERSONAL_COLUMN_ID.OWNER]: "owner",
  [API_KEYS_PERSONAL_COLUMN_ID.CREATED_AT]: "createdAt",
  [API_KEYS_PERSONAL_COLUMN_ID.EXPIRES_AT]: "expiresAt",
  [API_KEYS_PERSONAL_COLUMN_ID.LAST_USED]: "lastUsedAt",
};

export const API_KEYS_PERSONAL_SORT_FIELDS = Object.values(API_KEYS_PERSONAL_SORT_CONFIG);

export const API_KEYS_PERSONAL_INITIAL_SORT = {
  field: API_KEYS_PERSONAL_SORT_CONFIG[API_KEYS_PERSONAL_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
